import React from 'react';
import { Tabs } from '../components/redesign/ui';
import { ArrowsClockwise } from '@phosphor-icons/react';

// Note: TestModeBanner render lifted to the shell (see Layout.view.jsx). The
// container still computes the mode data for OverviewTab consumption + future
// use, but the banner itself is not rendered on this page.

export default function AdminPanelView({
  activeTab,
  availableTabs,
  onTabChange,
  loading,
  children,
}) {
  return (
    <div className="p-1">
      <div className="flex flex-col gap-6">
        {/* Header */}
        <div>
          <h1 className="font-serif text-2xl text-ink">Admin Panel</h1>
          <p className="mt-0.5 text-[13px] text-ink-muted">
            System configuration, routing rules, and integration settings.
          </p>
        </div>

        {/* Tab bar via redesign Tabs primitive — supports JSX labels */}
        <Tabs tabs={availableTabs} active={activeTab} onChange={onTabChange} />

        {/* Body */}
        {loading ? (
          <div className="flex justify-center py-16">
            <ArrowsClockwise size={28} className="animate-spin text-status-under-process" />
          </div>
        ) : (
          <div className="flex flex-col gap-6">{children}</div>
        )}
      </div>
    </div>
  );
}
